import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorsService } from './errors.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  constructor (
    private injector: Injector,
  ) {}

  handleError (error: Error | HttpErrorResponse) {
    const errorsService = this.injector.get(ErrorsService);

    if (error instanceof HttpErrorResponse && !navigator.onLine) {
      alert('No Internet Connection');
    } else {
      alert('An error has occured. We received all necessary information and resolve it soon.');
    }

    // Log error anyway
    errorsService.log(error);
  }
}

